import { useMutation } from 'react-query';

import { TRIAL_START_QUERY_KEYS } from '../constants';
import {
  validateTrialEmail,
  type ValidateTrialEmailResponse,
} from '../request';

type ValidateTrialEmailVariables = {
  email: string;
  signal?: AbortSignal;
};

export const useValidateTrialEmailMutation = () =>
  useMutation<ValidateTrialEmailResponse, Error, ValidateTrialEmailVariables>(
    [TRIAL_START_QUERY_KEYS.VALIDATE_EMAIL],
    ({ email, signal }: ValidateTrialEmailVariables) =>
      validateTrialEmail(email, signal)
  );
